import { createFileRoute } from '@tanstack/react-router'
import { PitchPrepare } from '../../../features/pitch/components/pitch-prepare'

export const Route = createFileRoute('/_protected/pitches/new')({
  component: PitchPrepareComponent,
})

function PitchPrepareComponent() {
  return (
    <div className="flex flex-1 items-center justify-center px-4">
      <div className="w-full max-w-2xl">
        <PitchPrepare />
      </div>
    </div>
  )
}
